import { render, staticRenderFns } from "./UsersModalUploadPermissionGroupsFile.vue?vue&type=template&id=1f65dc53&"
import script from "./UsersModalUploadPermissionGroupsFile.vue?vue&type=script&lang=js&"
export * from "./UsersModalUploadPermissionGroupsFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
